import { useProductPageStore } from '../../contexts/ProductPageStore'
import styles from './aplusCardContent.module.scss'

import React, { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'

import ErrorBoundary from 'Clutch/UtilityComponents/ErrorBoundary'
import MakerEnhance from 'maker-enhance'

const AplusCardContent = ({}) => {
  const aPlusContentScrollToLock = useProductPageStore((x) => x.aPlusContentScrollToLock)
  const canonicalUrl = useProductPageStore((state) => state.canonicalUrl)
  const embeddedMaker = useProductPageStore((state) => state.embeddedMaker)

  const [aPlusContentLoaded, setAPlusContentLoaded] = useState(false)

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0,
    rootMargin: '200px 0px',
  })

  useEffect(() => {
    if (inView && !aPlusContentScrollToLock?.active) {
      setAPlusContentLoaded(true)
    }
  }, [inView, aPlusContentScrollToLock?.active])

  // Add this effect to inject the script dynamically
  useEffect(() => {
    try {
      const aPlusShouldLoad = inView && !aPlusContentScrollToLock?.active
      const shouldLoad = aPlusShouldLoad || aPlusContentLoaded

      if (embeddedMaker && shouldLoad) {
        const wrapper = document.querySelector('.maker-wrapper-test')

        if (wrapper) {
          // Check if script already exists to prevent duplicates
          const existingScript = wrapper.querySelector(`script[src="${embeddedMaker}"]`)

          if (!existingScript) {
            const script = document.createElement('script')
            script.src = embeddedMaker
            script.async = true
            wrapper.appendChild(script)

            // Cleanup function to remove script when component unmounts
            return () => {
              if (wrapper && script.parentNode === wrapper) {
                wrapper.removeChild(script)
              }
            }
          }
        }
      }
    } catch (err) {
      console.error('Error loading embedded maker script:', err)
    }
  }, [embeddedMaker, inView, aPlusContentScrollToLock?.active, aPlusContentLoaded])

  const aPlusShouldLoad = inView && !aPlusContentScrollToLock?.active
  const shouldLoad = (aPlusShouldLoad || aPlusContentLoaded) && canonicalUrl

  return (
    <ErrorBoundary>
      <div ref={ref}></div>
      <div className={styles.aplus_card_wrapper}>
        <div className={'maker-wrapper-test'}>
          {!embeddedMaker && shouldLoad && <MemoMakerContent shouldLoad={shouldLoad} />}
        </div>
      </div>
    </ErrorBoundary>
  )
}

const MakerContent = ({ shouldLoad }) => {
  if (!shouldLoad) return false

  return <MakerEnhance user={'speedway'} instanceId={'card'} />
}

const MemoMakerContent = React.memo(MakerContent)

export default AplusCardContent
